export const ANYTIME_DATE = 'anytime' as const;
export const WHOLEYEAR_DATE = 'wholeyear' as const;
export const CHEAPEST_DATE = 'cheapest' as const;
export const DIRECT_OUTBOUND_AVAILABLE = 'DirectOutboundAvailable' as const;
export const DIRECT_INBOUND_AVAILABLE = 'DirectInboundAvailable' as const;
export const QUOTE_PRICE = 'Price' as const;
export const OUTBOUND_DEPART_DATE = 'Outbound_DepartureDate' as const;
export const INBOUND_DEPART_DATE = 'Inbound_DepartureDate' as const;
export const DEPARTURE_TIMES = 'DepartureTimes' as const;

export const DIRECT = 'Direct' as const;
export const INDIRECT = 'Indirect' as const;
export const DIRECT_INBOUND = 'DirectInbound' as const;
export const DIRECT_OUTBOUND = 'DirectOutbound' as const;
export const INDIRECT_INBOUND = 'IndirectInbound' as const;
export const INDIRECT_OUTBOUND = 'IndirectOutbound' as const;
export const TRACE_REFS = 'TraceRefs' as const;
export const TRACE_SEPARATOR = '|' as const;

export const PRICE_SOURCE_ID = 'PriceSourceId' as const;
export const BROWSE_SERVICE_MACHINE_NAME = 'MachineName' as const;
